import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const StateColumn = ({ customerId }) => {
  const [customer] = useSelector((state) => Global.selectEntitiesCustomersByIds(state, { customerIds: [customerId] })) ?? [];

  const { address = {} } = customer || {};
  const state = (address && address.state) || '';

  return state;
};

export const State = {
  getMessageDescriptor: () => messages.state,
  id: 'state',

  render: ({ customerId }) => {
    return <StateColumn customerId={customerId} />;
  },
};
